import React from 'react';
import { Link } from 'react-router';

import gobizLogoUrl from './gobiz-logo.png';
import emailIconUrl from './email-icon.png';

import styles from './ResetGoBizPasswordDone.css';

function ResetGoBizPasswordDone() {
  return (
    <div className={styles.container}>
      <div className={styles.logoRow}>
        <img src={gobizLogoUrl} />
      </div>

      <div className={styles.contentBox}>
        <div className={styles.emailIconRow}>
          <img src={emailIconUrl} />
        </div>

        <div className={styles.header}>
          <div className={styles.title}>Check Your Email</div>

          <div className={styles.instruction}>
            If your email address is in our database, you will receive an email
            with link password recovery in a few moments.
          </div>
        </div>

        <Link to="/login" className="btn btn-primary btn-block">
          Back to Sign In
        </Link>
      </div>
    </div>
  );
}

ResetGoBizPasswordDone.defaultProps = {};

export default ResetGoBizPasswordDone;
